import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {ConfigService} from '@shared-library';

@Injectable()
export class PreventTefcaPreDashboardHistoryNavigationGuard implements CanActivate {
  constructor(
    private router: Router,
    private configService: ConfigService,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): boolean {
    const identityVerificationHandled =
      this.configService.vaultProfileConfig$.identityVerificationHandledForSession === true;

    if (!this.configService.systemConfig$.tefcaMode || !identityVerificationHandled) {
      return true;
    }

    return this.router.getCurrentNavigation()?.trigger !== 'popstate';
  }
}
